export function reportClick(
  event_label: string,
  event_category = "Button Clicks",
) {
  // @ts-ignore
  if (typeof window !== "undefined" && window.gtag) {
    // @ts-ignore
    window.gtag("event", "click", {
      event_category,
      event_label,
    });
  }
}
